import React from 'react';
import RelativeComparisionChart from './RelativeComparisionChart';

const RelativeComparision = (props) => {
    const resultDetail = props.resultDetail !== undefined && props.resultDetail;
    return (
        <>
        <div className='card relative_comparisionWrap p-3 mb-4'>
 
            <h5 className='text_primary'>Relative Comparison</h5>
            <p className='mb-4'>Your Score vs. Average Score in Percentage</p>
     
            <>
            <RelativeComparisionChart resultDetail={resultDetail}/>
            </>
        </div>
        
        
        </>
    )
}

export default RelativeComparision